export default "//yastatic.net/s3/distribution/pythia/frontend/_/3ab70d58b865f909f462d2c6d848a4a6.png";